
// =======================
// Types
// =======================

import { AuthContext } from "../utility/useAuth";

export interface FormatConfig {
  dateFormat: string;        // "MMDDYYYY" | "DDMMYYYY" | "YYYYMMDD"
  dateSeparator: string;     // "/", "-", "."
  thousandSeparator: string; // ",", ".", " "
  decimalSeparator: string;  // ".", ","
}

// =======================
// Defaults (Hard fallback)
// =======================

export const defaultFormatConfig: FormatConfig = {
  dateFormat: "MMDDYYYY",
  dateSeparator: "/",
  thousandSeparator: ",",
  decimalSeparator: ".",
};

// =======================
// Exported live config
// =======================

export let assignedFormatConfig: FormatConfig = { ...defaultFormatConfig };

// =======================
// Loader (mutates export)
// =======================

export async function loadFormatConfig(
  auth: AuthContext,
  getOption: (auth: AuthContext, key: string) => Promise<string>
): Promise<void> {
  try {
    const [
      dateFormat,
      dateSeparator,
      decimalSeparator,
      thousandSeparator,
    ] = await Promise.all([
      getOption(auth, "DateFormat"),
      getOption(auth, "DateSeparator"),
      getOption(auth, "DecimalSeparator"),
      getOption(auth, "ThousandsSeparator"),
    ]);

    assignedFormatConfig = {
      dateFormat: dateFormat || defaultFormatConfig.dateFormat,
      dateSeparator: dateSeparator || defaultFormatConfig.dateSeparator,
      decimalSeparator: decimalSeparator || defaultFormatConfig.decimalSeparator,
      thousandSeparator:
        thousandSeparator || defaultFormatConfig.thousandSeparator,
    };
  } catch {
    // Never let UI break
    assignedFormatConfig = { ...defaultFormatConfig };
  }
}